module.exports = __webpack_public_path__ + "static/img/v3.fa077a4.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/v3.png
// module id = sv6X
// module chunks = 1